/**
 * Utility functions for error handling
 */

/**
 * Check if an error is related to token expiration/invalid token
 */
export const isTokenError = (errorMessage: string | null | undefined): boolean => {
  if (!errorMessage) return false;
  const message = errorMessage.toLowerCase();
  return (
    message.includes('expired') ||
    message.includes('invalid') ||
    message.includes('unauthorized') ||
    message.includes('token')
  );
};

/**
 * Get the appropriate severity for an error
 * Returns 'info' for token errors, 'error' for others
 */
export const getErrorSeverity = (errorMessage: string | null | undefined): 'error' | 'warning' | 'info' => {
  if (isTokenError(errorMessage)) {
    return 'info';
  }
  return 'error';
};

